<template>
  <div class="categories">
    <div v-if="brand !== 'gasgas'">
      <div class="row">
        <div class="col-sm-6 col-sm-offset-3">
          <div class="panel panel-vin text-center">
            <div class="panel-body">
              <div class="vin-search">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="vin"
                    class="form-control input-vin"
                    aria-label="VIN"
                    :placeholder="$t('message.typeVIN')"
                    v-on:keyup.enter="searchVIN()"
                  />
                  <span
                    @click="searchVIN()"
                    class="dl_search_start input-group-addon"
                    :class="`${brand}-bg`"
                  >
                    <img
                      class="search-icon"
                      src="https://teilecdn.com/assets/icons/search.svg"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="text-center col-md-12 divider">
          <div class="divider-container">
            <span>{{ $t('message.orSelectVehicle') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        v-for="(category, index) in categories"
        :key="index"
        class="col-sm-4 col-xs-6"
      >
        <div
          @click="selectCategory({ selectedCategory: category })"
          class="dl_search_start panel panel-category"
          :class="`${brand}-border-hover`"
          v-scroll-to="'#app'"
        >
          <div class="panel-body text-center">
            <div class="item">
              <img
                :src="`https://teilecdn.com/assets/categories/${brand}/${category}-${brand}.jpg`"
                class="image-category"
              />
            </div>
            <div class="category-name text-center">
              {{ $t(`message.${category}`) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Step1Category',
  computed: {
    vin: {
      get() {
        return this.$store.state.selectedVIN;
      },
      set(value) {
        this.$store.commit('setVIN', value);
      },
    },
    categories: {
      get() {
        return this.$store.state.availableCategories;
      },
    },
    brand: {
      get() {
        return this.$store.state.brand;
      },
    },
  },
  methods: {
    ...mapActions(['selectCategory', 'searchVIN']),
  },
};
</script>